module.exports = __webpack_public_path__ + "img/login-image.78e7aeef.svg";